module.exports = __webpack_public_path__ + "images/backgrounds/cosmos/large.be5121d350dd3e3ac97e.jpg";


//////////////////
// WEBPACK FOOTER
// ./resources/images/backgrounds/cosmos/large.jpg
// module id = CkdW
// module chunks = 0